import { TranslatorContext } from 'react-jhipster';
import * as muiLocales from '@mui/material/locale';
import { enUS, frFR } from '@mui/x-data-grid/locales';
import type { Localization } from '@mui/x-data-grid/internals';
import { setLocale } from 'app/store/reducers/app/locale';

TranslatorContext.setDefaultLocale('en');
TranslatorContext.setRenderInnerTextForMissingKeys(true);

interface ILanguage {
  name: string;
  mui: (muiLocales.Localization | Localization)[];
  rtl?: boolean;
}

export function getLocale(locales: string[] = []) {
  const navigatorLocale = new Intl.Locale(navigator.language);
  locales = locales.concat([localStorage.getItem('locale'), navigatorLocale.language, 'en']);
  return locales.find(locale => languages[locale] !== undefined);
}

export const languages: Record<string, ILanguage> = {
  en: { name: 'English', mui: [muiLocales.enUS, enUS] },
  fr: { name: 'Français', mui: [muiLocales.frFR, frFR] },
};

export const locales = Object.keys(languages).sort();

export const isRTL = (lang: string): boolean => languages[lang] && languages[lang].rtl;

export const registerLocale = store => {
  store.dispatch(setLocale(getLocale()));
};
